import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=7e535d4f&scoped=true"
import script from "./recordList.vue?vue&type=script&lang=js"
export * from "./recordList.vue?vue&type=script&lang=js"
import style0 from "./recordList.vue?vue&type=style&index=0&id=7e535d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e535d4f",
  null
  
)

export default component.exports